/**
 * Replaces all occurrences of a string in a string.
 *
 * @param {string} text
 * @param {string} needle
 * @param {string} replacement
 * @returns {string} - The replaced text.
 */
export const replaceTranslation = (text, needle, replacement) => text === null || text === void 0 ? void 0 : text.replace(needle, replacement);
//# sourceMappingURL=translation.js.map